import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { conformToMask } from 'text-mask-core';
import { Location } from '@angular/common';
import { LoggerService } from 'app/logger/logger.service';
const OTP_REGEX = /^\d+$/;
@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.css']
})
export class OtpVerifyComponent implements OnInit {
  // variable define
  verify_valid: boolean;
  otp_first: string;
  otp_second: string;
  otp_third: string;
  otp_fourth: string;
  username: string;
  mobile_no: string;
  public disable_div: string;
  public btn_value: string;
  private is_acc_setting: boolean;

  public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService,
    private authService: AuthService, private router: Router, private location:Location,private logger:LoggerService,
    private localStorageService: LocalStorageService) {
    // this.sharedService.setHeaderTitle('default_page');
    this.sharedService.setHeaderTitleDynamicallyTrueFalse('otp_verify', false);
    this.activatedRoute.params.subscribe((params: Params) => {
      this.is_acc_setting = (params['account_setting'] != undefined && params['account_setting'] == 'AccountSetting');
    });
    if (this.localStorageService.get('token') != null) {
      this.disable_div = '';
      this.btn_value = 'Verify';
      let methodName = this.constructor.name+'.verifyToken';
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then(res => {
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
          const person = res.results[0]['personal'];
          const service = res.results[0]['service'];
          if (res.status === 'success' && res.isTerminated === false) {

            var dataLayerEvent = 'otp verify';
            (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': person[0].id.toString() });
            this.sharedService.setHeaderUserLoggedIn('otp_verify', true, person[0]);
            if (this.is_acc_setting) {
              this.mobile_no = person[0]['tempMobile'];
              if(person[0]['tempMobile']=='')
              {
                this.mobile_no = person[0]['mobilePhoneNumber'];
              }
            } else {
              this.mobile_no = person[0]['mobilePhoneNumber'];
              this.mobile_no = conformToMask(this.mobile_no, this.phoneMask, {guide: false}).conformedValue;
              if (person[0]['tempOtpVerify']) {
                this.router.navigate(['./dashboard']);
              }
            }
            const that = this.sharedService;
            setTimeout(function () {
              that.setHeaderErrorMessage('otp_verify', false, 'notification error', '');
              that.setHeaderSuccessMessage('otp_verify', false, 'Your OTP has been successfully sent.');
              that.setHeaderTitle('otp_verify');
            }, 10);
            this.activatedRoute.params.subscribe((params: Params) => {
              this.username = params['username'];
            });
            this.verify_valid = false;
            this.otp_first = '';
            this.otp_second = '';
            this.otp_third = '';
            this.otp_fourth = '';
          } else {
            this.localStorageService.remove('token');
            this.localStorageService.remove('tempToken');
            this.router.navigate(['./enroll']);
          }
        }, (error)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: ex
          };
          this.logger.logError(JSON.stringify(logObj));
        });
    } else {
      this.router.navigate(['./enroll']);
    }
  }

  verifyValidate(verify_val: any) {
    if (!verify_val.target.value.match(OTP_REGEX)) {
      verify_val.target.value = '';
    }
    if (verify_val.target.id === 'otp_first') {
      this.otp_first = verify_val.target.value;
      if (this.otp_first !== '') {
        document.getElementById('otp_second').focus();
        this.otp_first = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_first').focus();
      }
    }
    if (verify_val.target.id === 'otp_second') {
      this.otp_second = verify_val.target.value;
      if (this.otp_second !== '') {
        document.getElementById('otp_third').focus();
        this.otp_second = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_first').focus();
      }
    }
    if (verify_val.target.id === 'otp_third') {
      this.otp_third = verify_val.target.value;
      if (this.otp_third !== '') {
        document.getElementById('otp_fourth').focus();
        this.otp_third = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_second').focus();
      }
    }
    if (verify_val.target.id === 'otp_fourth') {
      this.otp_fourth = verify_val.target.value;
      if (this.otp_fourth !== '') {
        this.otp_fourth = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_third').focus();
      }
    }

    if (this.otp_first !== '' && this.otp_second !== '' && this.otp_third !== '' && this.otp_fourth !== '') {
      this.verify_valid = true;
      if (verify_val.keyCode === 13) {
        document.getElementById('verify_btn').click();
      }
    } else {
      this.verify_valid = false;
    }
  }

  // make a REST call for otp verification
  verifyOTP() {
    this.disable_div = 'disable-div';
    this.verify_valid = false;
    this.btn_value = 'Verifying...';
    this.sharedService.setHeaderErrorMessage('otp_verify', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('otp_verify', false, 'Your OTP has been successfully sent.');
    let methodName = this.constructor.name+'.verifyOTP';
    this.authService.verifyOTP({
      'token': this.localStorageService.get('token'),
      'otpKey': this.otp_first + this.otp_second + this.otp_third + this.otp_fourth,
      'accessSetting': this.is_acc_setting
    })
      .then(res => {
        let logObj = {
          method: methodName,
          request: "token : [masked], otpKey: [masked], accessSetting: " + this.is_acc_setting,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        if (res.status === 'success') {
          this.sharedService.setHeaderErrorMessage('otp_verify', false, 'notification error', '');
          this.btn_value = 'Verify';
          this.disable_div = '';
          this.verify_valid = true;
          if (this.is_acc_setting) {
            // this.router.navigate(['./contact-info/AccountSetting']);
            this.location.back();
          } else {
            this.router.navigate(['./dashboard']);
          }
        } else {
          window.scrollTo(0, 0);
          this.sharedService.setHeaderErrorMessage('otp_verify', true, 'notification error', res.message);
          this.btn_value = 'Verify';
          this.disable_div = '';
          this.verify_valid = true;
        }
      }, (error)=>{
        let logObj = {
          method: methodName,
          request: "token : [masked], otpKey: [masked], accessSetting: " + this.is_acc_setting,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex)=>{
        let logObj = {
          method: methodName,
          request: "token : [masked], otpKey: [masked], accessSetting: " + this.is_acc_setting,
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }

  // make REST call for resend otp
  resendOTP() {
    this.sharedService.setHeaderErrorMessage('otp_verify', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('otp_verify', false, 'Your OTP has been successfully sent.');
    let methodName = this.constructor.name+'.resendOTP';
    this.authService.resendOTP({ 'username': this.username })
      .then(res => {
        let logObj = {
          method: methodName,
          request: 'username '+ this.username,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        window.scrollTo(0, 0);
        if (res.result.status === 'success') {
          this.sharedService.setHeaderSuccessMessage('otp_verify', true, 'Your OTP has been successfully sent.');
        } else {
          this.sharedService.setHeaderErrorMessage('otp_verify', true, 'notification error', res.result.message);
        }
      }, (error)=>{
        let logObj = {
          method: methodName,
          request: 'username '+ this.username,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex)=>{
        let logObj = {
          method: methodName,
          request: 'username '+ this.username,
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }

  OTPResend() {
    this.sharedService.setHeaderErrorMessage('otp_verify', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('otp_verify', false, 'Your OTP has been successfully sent.');
    let methodName = this.constructor.name+'.OTPResend';
    this.authService.resendOTP({ 'token': this.localStorageService.get('token'), 'sFor': 'mobile', 'accSetting': this.is_acc_setting })
      .then(res => {
        let logObj = {
          method: methodName,
          request: 'token : [masked]' + 'sFor : mobile'+ 'accSetting'+ this.is_acc_setting,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        window.scrollTo(0, 0);
        if (res.status === 'success') {
          this.sharedService.setHeaderSuccessMessage('otp_verify', true, 'Your OTP has been successfully sent.');
        } else {
          this.sharedService.setHeaderErrorMessage('otp_verify', true, 'notification error', res.message);
        }
      }, (error)=>{
        let logObj = {
          method: methodName,
          request: 'token : [masked]' + 'sFor : mobile'+ 'accSetting'+ this.is_acc_setting,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex)=>{
        let logObj = {
          method: methodName,
          request: 'token : [masked]' + 'sFor : mobile'+ 'accSetting'+ this.is_acc_setting,
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }

  // change mobile no
  chnageMobileNo() {
    this.sharedService.setHeaderErrorMessage('otp_verify', false, 'notification error', '');
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['account_setting'] !== undefined && params['account_setting'] === 'AccountSetting') {
        this.router.navigate(['./Profile/AccountSetting/ChangePhoneNumber/' + this.username]);
      } else {
        this.router.navigate(['./enrollment-wizard/change-phone-number/' + this.username]);
      }
    });

  }

  changeMobileNo() {
    this.sharedService.setHeaderErrorMessage('otp_verify', false, 'notification error', '');
    this.router.navigate(['./Profile/AccountSetting/ChangePhoneNumber/' + this.username]);
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['account_setting'] !== undefined && params['account_setting'] === 'AccountSetting') {
        this.router.navigate(['./Profile/AccountSetting/ChangePhoneNumber/' + this.username]);
      } else {
        this.router.navigate(['./enrollment-wizard/change-phone-number/' + this.username]);
      }
    });

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/auth/otp-verify/otp-verify.component.ts